import readings from "#simplified-word-readings" with { type: "json" };

/** The named accessor lets native Metro defer the other script's JSON initialization. */
export function getSimplifiedWordReadings() {
  return readings;
}
